






































import { Vue, Component, Prop } from 'vue-property-decorator';
import html2canvas from 'html2canvas';
import { Button } from 'vant';
import { getBaseinfo } from '@/api/api';
import * as config from '../config';

Vue.use(Button);
@Component({
  components: {},
})
export default class Poster extends Vue {
  @Prop() item!: any;
  @Prop() GradeData!: any;
  option = config.OPTHINES;
  isFakeData = false;
  dataURL = '';
  tableData = [];
  baseInfo = {};
  explain = '上游新闻邀你为我的作文点赞';
  base64 = '';

  created() {
    getBaseinfo(this.option.voteName).then((res: any) => {
      this.baseInfo = res.data;
    });
    if (this.item.nickname === '') {
      this.explain = '上游新闻邀你为我的作文点赞';
    } else {
      this.explain = this.item.nickname + '邀你为我的作文点赞';
    }
  }
  handClickAction() {
    this.$nextTick(() => {
      this.toImage();
    });
    // this.toImage();
  }
  toImage() {
    // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
    // window.onload = () => {
    const that = this;
    const height = (this.$refs.imageTofile as HTMLDivElement).offsetHeight;
    const width = (this.$refs.imageTofile as HTMLDivElement).offsetWidth;
    // const proxyURL = this.item.pictures[0]
    html2canvas(this.$refs.imageTofile as any, {
      useCORS: true,
      // allowTaint: true,
      scale: 2,
      height,
      width,
      scrollY: 0,
      scrollX: 0,
      backgroundColor: null, // 避免图片有白色边框
    }).then((canvas) => {
      const dataURL = canvas.toDataURL('image/png');
      // console.log('dataURL', dataURL);
      that.dataURL = dataURL;
      that.isFakeData = false;
      that.tableData = [];
    });
  }
  // }
}
